function About() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">About Us</h1>
      <p>We are building a modern job board to connect employers and job seekers efficiently...</p>
    </div>
  );
}
export default About;
